import { cn } from '../../lib/utils';

interface KeyValueRowProps {
  label: string;
  value: string;
  muted?: boolean;
  highlight?: boolean;
  bold?: boolean;
}

/**
 * Label-on-left, value-on-right row used in receipt-style summary boxes
 * (finalize confirm modal, draft master preview, totals breakdown). Promoted
 * from per-route `Row` helpers to share one definition.
 */
export function KeyValueRow({ label, value, muted, highlight, bold }: KeyValueRowProps) {
  return (
    <div className={cn('flex justify-between items-baseline', muted && 'text-foreground-muted')}>
      <span className="text-[12px] uppercase tracking-wide">{label}</span>
      <span className={cn('font-mono', bold && 'font-bold', highlight && 'text-primary text-base font-bold')}>
        {value}
      </span>
    </div>
  );
}
